export const INTRO_SECTION_LABEL = 'Introduce yourself to breeders';

export const INTRO_REPLY_RATE_LINE =
  'Breeders reply to almost twice as many buyers who introduce themselves.';

export const INTRO_PLACEHOLDER =
  'Who lives in your home, your experience with dogs, and when you hope to bring a puppy home.';

export const INTRO_COPY_VARIANT = 'C';
